import { apiRequest } from "./axiosConfig";

// Fetch the current subscription data for the user
export const fetchCurrentSubscription = async () => {
  return await apiRequest("GET", "/api/subscriptions/current");
};

// Create a Stripe checkout session
export const createCheckoutSession = async (data) => {
  return await apiRequest("POST", "/api/subscriptions/checkout-session", data);
};

// Create a Stripe billing portal session
export const createBillingPortalSession = async (data) => {
  return await apiRequest("POST", "/api/subscriptions/billing-portal", data);
};

// Fetch payment history for the user
export const fetchPaymentHistory = async () => {
  return await apiRequest("GET", "/api/subscriptions/payment-history");
};
